import { Box } from '@mui/material'
import Step from '@mui/material/Step'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector'
import StepLabel from '@mui/material/StepLabel'
import Stepper, { StepperProps } from '@mui/material/Stepper'
import { styled } from '@mui/material/styles'
import * as React from 'react'

const ColorlibConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#F2F2F2'
    }
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#F2F2F2'
    }
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1
  }
}))

export interface IStep {
  label: string
  icon: string
  color: string
  endDate?: string
}

interface IColoredStepperProps extends StepperProps {
  steps: IStep[]
  activeStep?: number
}

export const ColoredStepper = ({ steps, activeStep = 100, sx }: IColoredStepperProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
        sx={{
          // Shift connector to icon’s center
          '.MuiStepConnector-root': {
            top: '41px !important',
            zIndex: 0
          },
          // Circle container is on top
          '.MuiStepLabel-iconContainer': {
            position: 'relative',
            zIndex: 1,
            padding: 0,
            margin: 0
          },
          width: '100%',
          ...sx
        }}>
        {steps.map(step => (
          <Step key={step.label} sx={{ textAlign: 'center' }}>
            <StepLabel
              sx={{
                '& .MuiStepLabel-label': {
                  fontFamily: 'DMSans',
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '10px'
                }
              }}
              StepIconComponent={() => (
                <div
                  style={{
                    width: '80px',
                    height: '80px',
                    backgroundColor: step.color,
                    borderRadius: '999px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                  <img src={step.icon} alt={`${step.label} icon`} width={'40px'} height={'40px'} />
                </div>
              )}>
              {step.label}
            </StepLabel>
            <span style={{ fontSize: '14px', fontWeight: 400, padding: '6px 14px 6px 14px', marginTop: '20px', borderRadius: '50px', backgroundColor: step.color }}>
              {step.endDate}
            </span>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
